// toast container is in App.js

export function generateToastConfig({mode}){
  const theme = mode === "dark" ? "dark" : "light";
  return {
    theme,
    hideProgressBar:  true,
    autoClose:        12000, // 12s
  }
}